<template>
  <div
    class="rt-input-money"
    @mouseenter="inputHovering = true"
    @mouseleave="inputHovering = false"
  >
    <el-input
      v-model="currentValue"
      :placeholder="computedInputPlaceholder"
      :readonly="readonly"
      :disabled="computedDisabled"
      type="text"
      @focus="focusHandler"
      @blur="blurHandler"
      @change="changeHandler"
    >
      <span
        slot="prefix"
        class="prefix"
      >
        <slot name="prefix" />
      </span>
    </el-input>
    <rt-icon
      v-if="!computedDisabled && !showClose && showSuffixIcon"
      :color="SCSS_VARIABLES.NEUTRAL_COLOR_SECONDARY"
      name="rt-base-record-lined"
    />
    <rt-icon
      v-if="showClose"
      slot="suffix"
      :name="computedIconName"
      :style="computedClearIconStyle"
      :color="SCSS_VARIABLES.COLOR_SECONDARY"
      class="rt-xpc-input-clearicon"
      @click="clear"
    />
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon.vue';
import inputFocusMixins from './inputFocusMixins.js';
import xpcConfig from '../../config';
import Placeholder from './placeholder.js';

export default {
  name: 'RtInputMoney',
  components: { RtIcon },
  mixins: [inputFocusMixins, Placeholder],
  props: {
    value: [String, Number],
    datafieldname: String,
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: 2
    },
    clearable: {
      type: Boolean,
      default: undefined
    },
    // 自定义清空按钮图标
    clearIconName: {
      type: String,
      default: undefined
    },
    // 自定义清空按钮位置
    clearIconRight: {
      type: Number,
      default: 0
    },
    /**
     * @public 是否展示后侧图标
     */
    showSuffixIcon: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentValue: this.$dealThousands(this.value, this.precision),
      inputHovering: false
    };
  },
  inject: {
    elForm: {
      default: ''
    },
    rtFormItem: {
      default: ''
    }
  },
  computed: {
    computedClearable () {
      return this.clearable === undefined
        ? this.elForm &&
            this.elForm.$attrs &&
            this.elForm.$attrs['all-clearable']
        : this.clearable;
    },
    computedIconName () {
      return this.clearIconName || xpcConfig.get('clearicon.clearIconName');
    },
    computedClearIconStyle () {
      let style = {};
      if (this.computedClearable) {
        style['marginRight'] =
          this.clearIconRight ||
          xpcConfig.get('clearicon.clearIconRight') + 'px';
      }
      return style;
    },
    showClose () {
      return (
        this.value !== '' &&
        this.inputHovering &&
        !this.computedDisabled &&
        this.computedClearable
      );
    },
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  watch: {
    value: {
      handler (newValue) {
        this.currentValue = this.$dealThousands(newValue, this.precision);
        if (
          newValue !== undefined &&
          newValue !== null &&
          newValue !== '' &&
          this.elForm &&
          this.elForm.validateField &&
          this.rtFormItem &&
          this.rtFormItem.prop
        ) {
          this.elForm.validateField(this.rtFormItem.prop);
        }
      },
      immediate: true
    }
  },
  methods: {
    clear () {
      this.currentValue = undefined;
      this.changeHandler(this.currentValue);
      this.$emit('clear');
    },
    focusHandler () {
      this.$emit('focus');
    },
    blurHandler () {
      this.$emit('blur', this.currentValue, null, this.datafieldname);
    },
    changeHandler (val) {
      if (val !== this.value) {
        this.currentValue = this.$dealThousands(
          this.currentValue,
          this.precision
        );
        val = this.currentValue
          ? this.strToNumber(this.currentValue)
          : undefined;
        this.$emit('input', val, null, this.datafieldname);
        this.$emit('change', val, null, this.datafieldname);
      }
    },
    strToNumber (str) {
      return +str.replace(',', '');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtInputMoney.vue?291f0ea8